import AuthRoute from '../../components/layouts/AuthRoute/AuthRoute';
import { Column } from '@lightningjs/ui-components';
import { Colors, Router, Storage, Utils } from '@lightningjs/sdk';
import VODInfo from '../Home/components/VODInfo';
import Lightning from '@lightningjs/sdk/src/Lightning';
import PaidTitleModal from '../Home/components/UpgradeModal';

export default class MyList extends AuthRoute {
  static _template() {
    return {
      ...super._template(),
      PaidTitleModal: {
        zIndex: 200,
        w: 1920,
        h: 1080,
        rect: true,
        color: Colors('#000000').get(),
        type: PaidTitleModal,
        visible: false,
      },
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      Content: {
        x: 200,
        y: 0,
        h: 500,
        w: 1720,
        type: VODInfo,
        visible: false,
      },
      Wrapper: {
        x: 100,
        y: 580,
        h: 600,
        w: 1720,
        clipping: true,
        Column: {
          collision: true,
          x: 21,
          y: 40,
          type: Column,
          plinko: true,
          style: { itemSpacing: 50 },
        },
      },
      ResultText: {},
      Title: {
        x: 300,
        y: 530,
        w: 100,
        h: 40,
      },
    };
  }

  get id() {
    return 'MyList';
  }
  set title(val) {
    return (this._title = val);
  }

  set myListTitle(val) {
    return (this._myListTitle = val);
  }

  $hidePaidTitleModal() {
    this.tag('PaidTitleModal').visible = false;
    this._setState('Column');
  }

  get _Column() {
    return this.tag('Wrapper.Column');
  }
  set data(val) {
    return (this._data = val);
  }

  _handleLeft() {
    if (!Router.isNavigating()) {
      Router.focusWidget('sidebar');
    }
  }
  _enable() {
    this._setState('Column');
    this.tag('Content.Info').patch({
      zIndex: 100,
    });
    if (this._data != undefined && this._data.items.length > 0) {
      this.tag('Content').patch({
        visible: true,
      });
      this.tag('Title').patch({
        text: {
          text: this._myListTitle,
          textColor: Colors('#d6d6d6').get(),
          textAlign: 'center',
          fontFace: 'OpenSans-Regular',
          fontSize: 30,
        },
      });
      this.tag('ResultText').patch({
        visible: true,
        y: 460,
        x: 445,
        text: {
          text: '',
          fontSize: 36,
          lineHeight: 40,
          textColor: Colors('#fafafa').get(),
        },
      });
    } else {
      this.tag('Content').patch({
        visible: false,
      });
      this.tag('ResultText').patch({
        visible: true,
        y: 460,
        x: 445,
        text: {
          text: 'Anything you add to My List will appear here.',
          fontSize: 36,
          lineHeight: 40,
          textColor: Colors('#fafafa').get(),
        },
      });
      this.tag('Title').patch({
        text: {
          text: '',
          textColor: Colors('#d6d6d6').get(),
          textAlign: 'center',
          fontSize: 30,
        },
      });
    }
  }
  _firstEnable() {
    this._Column.patch({
      x: 200,
    });
  }
  $changeVODInfo({ title, description, category, duration, cover, rating, votes, contentRating }) {
    // Kreiramo debounced funkciju samo jednom
    if (!this._debouncedChangeVOD) {
      this._debouncedChangeVOD = this._debounce(
        ({ title, description, category, duration, cover, rating, votes, contentRating }) => {
          const ratingText = `${rating}/10`;
          const categoryText = category && category.length > 0 ? category.join(' • ') : '';
          const parts = duration.split(':').map((part) => parseInt(part));
          let seconds = 0;
          if (parts.length === 3) {
            seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
          } else if (parts.length === 2) {
            seconds = parts[0] * 60 + parts[1];
          }

          // Modify the duration text
          let hours = parts.length === 3 ? parts[0].toString().padStart(2, '0') : '00';
          let minutes =
            parts[parts.length - 2] !== undefined
              ? parts[parts.length - 2].toString().padStart(2, '0')
              : '00';
          let secondsPart = parts[parts.length - 1].toString().padStart(2, '0');
          const durationText =
            seconds >= 3600
              ? `${hours}:${minutes}:${secondsPart} | `
              : `${minutes}:${secondsPart} | `;

          // Resetujemo alpha za fade-in efekat
          const contentInfo = this.tag('Content.Info');
          contentInfo.alpha = 0;
          const contentCover = this.tag('Content.Cover');
          contentCover.alpha = 0;

          // Patch-ujemo Content.Info sa novim vrednostima
          contentInfo.patch({
            Title: { text: { text: title } },
            Informations: {
              DurationAndIcon: {
                Svg: {
                  x: seconds > 3600 ? 130 : 90,
                  texture: lng.Tools.getSvgTexture(
                    Utils.asset('images/movie-info-icons/star.svg'),
                    20,
                    20
                  ),
                },
                text: { text: durationText },
              },
              Rating: {
                x: seconds > 3600 ? 165 : 125,
                text: { text: `IMDB ${ratingText}` },
              },
              Votes: {
                x: seconds > 3600 ? 315 : 275,
                text: { text: `(${votes})` },
              },
              ContentRating: {
                x: seconds > 3600 ? 375 : 330,
                text: { text: `| (${contentRating})` },
              },
            },
            Category: {
              text: { text: categoryText },
            },
            Description: { text: { text: description } },
          });

          // Patch-ujemo sliku (Cover)
          contentCover.patch({
            texture: { src: cover },
          });

          // FadeIn animacija za Content.Info
          contentInfo.setSmooth('alpha', 1, { duration: 0.5, delay: 0.1 });
          // FadeIn animacija za sliku (Cover)
          contentCover.setSmooth('alpha', 1, { duration: 0.5, delay: 0.1 });
        },
        500
      ); // Debounce delay od 300ms
    }

    // Zovemo debounced funkciju
    this._debouncedChangeVOD({
      title,
      description,
      category,
      duration,
      cover,
      rating,
      votes,
      contentRating,
    });
  }

  // Debounce funkcija
  _debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  $unselectCurrentIndex() {
    let currentIndex = this._Column.selectedIndex;
    let rowIndex = (this._Column.items[currentIndex].selectedIndex = undefined);
  }

  $setFocus({ rowIndex, index }) {
    let modifiedIndex = index % 6;
    // this._Column.selectedIndex = rowIndex;
    this._Column.scrollTo(rowIndex, 400);
    this._Column.items[rowIndex].selectedIndex = modifiedIndex;
  }

  $scroll(event) {
    this._handleScroll(event);
  }

  _handleScroll(event) {
    // Kreiramo debounced funkciju samo jednom
    if (!this._debouncedScroll) {
      this._debouncedScroll = this._debounce((event) => {
        let currentIndex = this._Column.selectedIndex;
        let nextIndex = currentIndex + 1;
        let previousIndex = currentIndex - 1;

        if (event.deltaY > 0) {
          this._Column.scrollTo(nextIndex, 50);
        } else if (event.deltaY < 0) {
          this._Column.scrollTo(previousIndex, 50);
        }
      }, 200); // Debounce delay od 200ms, možeš ga promeniti po potrebi
    }

    // Zovemo debounced funkciju
    this._debouncedScroll(event);
  }

  // Debounce funkcija
  _debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  $handleEnter() {
    let fp = this.application.focusPath;
    let isProtected = (fp && fp.length > 0 && fp[fp.length - 1])._isProtected;
    let activeTile = fp[fp.length - 1].data || {};
    switch (activeTile && activeTile.kind) {
      case 'movie':
        if (isProtected) {
          this.tag('PaidTitleModal').visible = true;
          this._setState('PaidTitleModal');
        } else {
          Storage.set('video', { id: activeTile.id, watchList: 0 });
          Router.navigate(`movie/${activeTile.id}`);
        }
        break;
      case 'subseries':
        this.navigate(`series/${activeTile.id}`);
        break;
      case 'collection':
        this.navigate(`categories/${activeTile.id}`);
    }
  }

  static _states() {
    return [
      class PaidTitleModal extends this {
        _getFocused() {
          return this.tag('PaidTitleModal');
        }
      },
      class Column extends this {
        _getFocused() {
          return this._Column;
        }
      },
    ];
  }
}
